export const OurStory = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            {/* Left Column - Title and Image */}
            <div className="flex-1">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-primary md:text-left text-center">
                Nuestra Historia
              </h2>
              <div className="flex justify-center md:justify-start">
                <div className="w-full max-w-md h-[400px]">
                  <img 
                    src="https://pub-168b813ffa0f41548428789ca73fba4e.r2.dev/nuestra-foto.png"
                    alt="Familia FinancieraMente" 
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            {/* Text Content */}
            <div className="flex-1 prose prose-lg">
              <p className="text-gray-700 mb-6 text-base md:text-lg">
                Todo comenzó cuando Welington, un emprendedor exitoso y padre de Milagros, una niña brillante de 6 años, 
                se dio cuenta de algo preocupante: la escuela tradicional no estaba preparando a su hija para 
                el mundo real de las finanzas y los negocios.
              </p>
              <p className="text-gray-700 mb-6 text-base md:text-lg">
                Como emprendedor, Welington sabía que el verdadero camino hacia la libertad financiera y el éxito 
                personal estaba en el emprendimiento y la educación financiera. Había aprendido estas lecciones 
                por el camino difícil, y quería algo mejor para Milagros.
              </p>
              <p className="text-gray-700 mb-6 text-base md:text-lg">
                "¿Por qué esperar a que nuestros hijos sean adultos para aprender sobre dinero y negocios?", 
                se preguntaba. Fue entonces cuando nació FinancieraMente, con una misión clara: transformar 
                la educación financiera para la próxima generación.
              </p>
              <p className="text-gray-700 text-base md:text-lg">
                Hoy, FinancieraMente está cambiando la vida de miles de niños, preparándolos para un futuro 
                donde el emprendimiento y la inteligencia financiera son habilidades fundamentales. Porque 
                creemos que cada niño merece la oportunidad de aprender las habilidades que realmente 
                importan para su futuro financiero.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};